import { useState } from 'react';

import { CUSTOMS_CODE_COUNTRIES } from '../../../constants/locations';

export const useCustomsCode = (countryCode: string = '') => {
  const [error, setError] = useState(false);
  const [value, setValue] = useState('');

  const required = CUSTOMS_CODE_COUNTRIES.includes(countryCode);

  return {
    error,
    required,
    setValue,
    setError,
    valid: required ? Boolean(value) : true,
    value,
  };
};
